import { RestClient } from '@/modules/axios';

export default {
    state: {
        user: [],
        isLoggedIn: false,
        restClientModule: null,
    },
    getters: {
        getIsLoggedIn(state) {
            return sessionStorage.getItem('isLoggedIn') || state.isLoggedIn;
        },
    },
    mutations: {
        setLoggedIn(state, payload) {
            sessionStorage.setItem('isLoggedIn', payload);
            state.isLoggedIn = payload;
        },
    },
    actions: {
        fetchUser({ dispatch }, payload) {
            return dispatch('getRestClientModule')
                .then((client) => {
                    return client.post('/api/login', payload).then(() => {
                        dispatch('setLoggedInState', true);
                        return Promise.resolve();
                    });
                })
                .catch(() => {
                    return Promise.reject();
                });
        },

        getRestClientModule(context) {
            if (!context.state.restClientModule) {
                context.state.restClientModule = new RestClient('', context);
            }
            return context.state.restClientModule;
        },

        setLoggedInState({ commit }, payload) {
            commit('setLoggedIn', payload);
        },
    },
};
